import React, {Component} from 'react';
import {StaticQuery, graphql} from "gatsby"

import MainLayout from '../layouts/MainLayout';
import {Helmet} from "react-helmet";

import ImageHeader from '../components/ImageHeader';
import ContentList from '../components/ContentList';

import {theme, brk} from '../styles/constants.js';
import FullWidthLayout from "../layouts/FullWidthLayout";
import styled from "styled-components";



class Emmanuel extends Component {
    render() {
        const {
            data
        } = this.props;

        return (
            <MainLayout>
                <Helmet>
                    <title>Fleur DELANGLE Paris - { data.edges[0].node.name }</title>
                    <meta name="description" content={data.edges[0].node.seoDescription}/>
                    <meta id="meta-keywords" name="keywords" content={data.edges[0].node.seoKeywords}/>
                </Helmet>
                <div>

                    <FullWidthLayout style={{backgroundColor: 'white', color: 'black'}}>
                        <ImageHeader image={data.edges[0].node.header}/>
                        <ContentList content={data.edges[0].node.contentList} />
                    </FullWidthLayout>




                </div>
            </MainLayout>
        )
    }
}


export default () => (
    <StaticQuery
        query={graphql`
          query emmanuelQuery {
            content : allContentfulPage(filter: {slug: {eq: "emmanuel"}}) {
                edges {
                  node {
                    id
                    slug
                    name
                    seoDescription
                    seoKeywords
                    header {
                      id
                      file {
                        url
                        fileName
                        contentType
                      }
                      fluid(maxWidth : 2000) {
                        src
                        srcSet
                        srcWebp
                        sizes
                      }
                    }
                    contentList {
                        ... on ContentfulContentBlock {
                        slug
                        title
                        subtitle
                        buttonLabel
                        buttonLink
                        images {
                          id
                          file {
                            url
                            fileName
                            contentType
                          }
                          fluid(maxWidth: 1200) {
                            sizes
                            src
                            srcSet
                            srcWebp
                            srcSetWebp
                          }
                        }
                        textContent {
                          id
                          childMarkdownRemark {
                            html
                          }
                        }
                      }
                    }
                  }
                }
              }
          }
        `}
        render={data => (
            <Emmanuel data={data.content}/>
        )}
    />
)
